/**
 * ANQ.Rate.API 
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { RateDto } from './rateDto';
import { ResourceDto } from './resourceDto';

export interface CreateRateMapDto { 
    batchId?: string;
    rate?: RateDto;
    resource?: ResourceDto;
}